import React from "react";
import { Header, Icon, Image, List, Popup } from "semantic-ui-react";
import Leaderboard from "./Leaderboard";
import { withRouter } from "react-router-dom";
import { ROUTES_NAMES } from "../../routes";
import FeedToBookmarkedClouds from "./FeedToBookmarkedClouds";
import Quotes from "./Quotes";
import Breathe from "./Breathe";

class CloudsFeedMetaPanel extends React.Component {
  state = {
    channel: this.props.currentChannel,
    privateChannel: this.props.isPrivateChannel,
    activeIndex: 0,
  };

  setActiveIndex = (event, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  formatCount = (num) =>
    num > 1 || num === 0 ? `${num} comments` : `${num} comment`;

  displayTopPosters = (posts) =>
    Object.entries(posts)
      .sort((a, b) => b[1] - a[1])
      .map(([key, val], i) => (
        <List.Item key={i}>
          <Image avatar src={val.avatar} />
          <List.Content>
            <List.Header as="a">{key}</List.Header>
            <List.Description>{this.formatCount(val.count)}</List.Description>
          </List.Content>
        </List.Item>
      ))
      .slice(0, 2);

  bookmarked_feed_navigation() {
    return this.props.bookmarkedClouds ? (
      <React.Fragment>
        <Header
          onClick={() => this.props.history.push(ROUTES_NAMES.cloudsFeed)}
        >
          Clouds Feed
        </Header>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Header
          onClick={() => this.props.history.push(ROUTES_NAMES.bookmarkedClouds)}
        >
          Bookmarked clouds
        </Header>
      </React.Fragment>
    );
  }

  render() {
    const { privateChannel } = this.state;
    const {} = this.props;

    if (privateChannel) return null;

    return (
      <React.Fragment>
        <Header as="h2">
          <span>
            <Icon name="bullhorn" color="black" />
            Leaderboard{" "}
            <Popup
              position="bottom left"
              trigger={
                <Icon
                  style={{ verticalAlign: "middle" }}
                  size="mini"
                  circular
                  name="info"
                />
              }
            >
              You get 10 gems everytime you write a cloud or a diary. Also, on a
              particular day,if you happen to maintain a streak of say, 5 days
              for the diary, then you'll be awarded 5*10 gems for that day.
            </Popup>
          </span>
        </Header>
        <Leaderboard />

        <FeedToBookmarkedClouds
          bookmarkedClouds={this.props.bookmarkedClouds}
        />
        <Quotes />
        <Breathe />
      </React.Fragment>
    );
  }
}

export default withRouter(CloudsFeedMetaPanel);



// WEBPACK FOOTER //
// ./src/components/MetaPanel/CloudsFeedMetaPanel.js